import React, { useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";

// Internal components
import Title from "components/Title";
import Btn from "components/Btn";
import LanguagePicker from "components/LanguagePicker";
import Meta from "components/Meta";

// External components
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";

// Contexts
import { DataContext } from "contexts/Data";

const Galleri = () => {
    const { data, language, setLanguage } = useContext(DataContext);
    const { pathname } = useLocation();
    useEffect(() => {
        if (pathname === "/gallery") {
            setLanguage("en");
        } else if (pathname === "/galleri") {
            setLanguage("no");
        }
    }, [pathname]);
    useEffect(() => {
        const addImage = (wrapper, src) => {
            let wrapperElement = document.getElementById(wrapper);
            const div = document.createElement("div");
            const img = document.createElement("img");
            div.classList.add("galleri__grid__item");
            img.classList.add("galleri__grid__item__img");
            img.setAttribute(
                "src",
                process.env.PUBLIC_URL + "/images/workshops/" + src + ".jpg"
            );
            div.appendChild(img);
            wrapperElement.appendChild(div);
        };

        // 1 mars images
        for (let i = 0; i < 2; i++) {
            addImage("gallery-images", `1_mars/${i}`);
        }
        // 5 februar images
        for (let i = 0; i < 5; i++) {
            addImage("gallery-images", `5_feb/${i}`);
        }

        // 12 februar images
        for (let i = 0; i < 12; i++) {
            addImage("gallery-images", `12_feb/${i}`);
        }

        // 29 jan images
        for (let i = 0; i < 8; i++) {
            addImage("gallery-images", `29_jan/${i}`);
        }
    }, []);
    const options = {
        settings: { lightboxTransitionSpeed: 0, slideTransitionSpeed: 0 },
    };
    return (
        <>
            <Meta
                title={data.seo.galleri.title || ""}
                description={data.seo.galleri.description || ""}
                image={data.seo.galleri.image || ""}
            />
            <LanguagePicker
                redirects={{
                    no: data.pages.galleri.to.no,
                    en: data.pages.galleri.to.en,
                }}
            />
            <section className="galleri">
                <div className="container galleri__container">
                    <div className="galleri-thread" />

                    <div className="galleri__content">
                        <Title title="Workshops" modifier="galleri" />
                        <SimpleReactLightbox>
                            <SRLWrapper options={options}>
                                <div
                                    className="galleri__grid"
                                    id="gallery-images"
                                ></div>
                            </SRLWrapper>
                        </SimpleReactLightbox>
                    </div>
                </div>
                <Btn
                    className="btn--patch-vertical next-btn"
                    to={data.pages.broderier.to[language]}
                >
                    {data.nextButton[language]}
                </Btn>
            </section>
        </>
    );
};

export default Galleri;
